import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';

@Injectable()
export class PumpingServiceFeature implements IFlagFeature {
  name = Features.PumpingService;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return (
      params && params.businessLineCode && container[this.name].getValue().split(' ').includes(params.businessLineCode)
    );
  }
}
